export const WORKSPACE = 0
export const MARKET_ANALYSIS = 1
export const INNOVATION_PROJECT = 2
export const INNOVATION_FIELD = 3

export const TABS = [MARKET_ANALYSIS, WORKSPACE, INNOVATION_PROJECT, INNOVATION_FIELD]
